import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';
import { useTheme } from '../contexts/ThemeContext';
import TranslatableText from './TranslatableText';

const Breadcrumb = () => {
  const location = useLocation();
  const { isDark } = useTheme();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Mapping for better display names
  const breadcrumbNameMap = {
    'about': 'About Us',
    'principal-message': 'Principal Message',
    'vision-mission': 'Vision & Mission',
    'smc': 'School Management Committee',
    'history': 'History & Legacy',
    'academics': 'Academics',
    'academic-calendar': 'Academic Calendar',
    'subjects': 'Subjects Offered',
    'examination': 'Examination System',
    'academic-policies': 'Academic Policies',
    'admissions': 'Admissions',
    'fee-structure': 'Fee Structure',
    'eligibility': 'Eligibility Criteria',
    'apply-online': 'Online Application',
    'admission-faqs': 'Admission FAQs',
    'campus-tour': 'Campus Tour',
    'laboratories': 'Laboratories',
    'library': 'Library',
    'sports-facilities': 'Sports Facilities',
    'transport': 'Transport',
    'events': 'Events & Activities',
    'clubs': 'Clubs & Societies',
    'sports': 'Sports & Games',
    'cultural': 'Cultural Programs',
    'student-council': 'Student Council',
    'achievements': 'Achievements',
    'news': 'Latest News',
    'notices': 'Notices',
    'circulars': 'Circulars',
    'press-releases': 'Press Releases',
    'downloads': 'Downloads',
    'gallery': 'Photo Gallery',
    'video-gallery': 'Video Gallery',
    'virtual-tour': 'Virtual Tour',
    'events-gallery': 'Events Gallery',
    'contact': 'Contact Us'
  };

  if (location.pathname === '/') {
    return null; // Don't show breadcrumb on home page
  }

  return (
    <nav className={`${isDark ? 'bg-dark-surface border-dark-border' : 'bg-gray-50 border-gray-200'} border-b py-3`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ol className="flex items-center space-x-2 text-sm">
          <li>
            <Link
              to="/"
              className={`flex items-center ${isDark ? 'text-dark-text-secondary hover:text-blue-400' : 'text-gray-500 hover:text-blue-600'} transition-colors`}
            >
              <HomeIcon className="w-4 h-4 mr-1" />
              <TranslatableText text="Home" />
            </Link>
          </li>
          
          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            const displayName = breadcrumbNameMap[name] || name.charAt(0).toUpperCase() + name.slice(1);

            return (
              <li key={name} className="flex items-center">
                <ChevronRightIcon className={`w-4 h-4 mx-2 ${isDark ? 'text-dark-text-secondary' : 'text-gray-400'}`} />
                {isLast ? (
                  <span className={`font-medium ${isDark ? 'text-dark-text' : 'text-gray-900'}`}>
                    <TranslatableText text={displayName} />
                  </span>
                ) : (
                  <Link
                    to={routeTo}
                    className={`${isDark ? 'text-dark-text-secondary hover:text-blue-400' : 'text-gray-500 hover:text-blue-600'} transition-colors`}
                  >
                    <TranslatableText text={displayName} />
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;